module.exports = __webpack_public_path__ + "static/media/search.e0d5f64e.svg";